// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env as rawEnv } from './.env';
const env: { [key: string]: string | undefined } = Object.fromEntries(
  Object.entries(rawEnv).map(([key, value]) => [key, value ?? undefined])
);

// export const environment = {
//   production: false,
//   version: env['npm_package_version'],
//   homeUrl: 'https://qas.thkee.dev',
//   homeUrlSSL: 'https://qas.thkee.dev',
//   serverUrl: 'https://qa.check.thkee.dev',
//   uppyCompanionUrl: 'https://qa.comp.thkee.dev',
//   defaultLanguage: 'ar-SA',
//   isAdmin: false,
//   geolocationUrl: 'https://geolocation.thkee.com',
//   supportedLanguages: [
//     { code: 'ar-SA', name: 'Arabic' },
//     { code: 'en-US', name: 'English' },
//   ],
//   tapPublicKey: 'pk_test_q6Odm4txscnSGBMje3hYoPC5',
//   baseUrlWebsocket: 'qa.check.thkee.dev',
//   googleClientId: '1085924331203-k5rr1nanteeo77el8pf6ul0noue93o15.apps.googleusercontent.com',

//   firebaseConfig: {
//     apiKey: 'AIzaSyCDGeitXmkuTwGKggtLrg1O9NHXZEaH4aQ',
//     authDomain: 'thkee-qa.firebaseapp.com',
//     projectId: 'thkee-qa',
//     storageBucket: 'thkee-qa.firebasestorage.app',
//     messagingSenderId: '628299107846',
//     appId: '1:628299107846:web:1a068e47156b0a52a93d87',
//   },
//   logRocketEnabled: false, // Add this flag
//   siteKey: '0x4AAAAAAABUtlO8-1LJhFyQ', // Cloudflare site key
//   videoJsLicense: '100f5a560149555612',
// };

export const environment = {
  production: env['NODE_ENV'] === 'production',
  version: env['npm_package_version'] || 'dev',
  homeUrl: env['QA_HOME_URL'] || 'https://qas.thkee.dev',
  homeUrlSSL: env['QA_HOME_URL'] || 'https://qas.thkee.dev',
  serverUrl: env['QA_SERVER_URL'] || 'https://qa.check.thkee.dev',
  uppyCompanionUrl: env['QA_UPPY_COMPANION_URL'] || 'https://qa.comp.thkee.dev',
  defaultLanguage: env['DEFAULT_LANGUAGE'] || 'ar-SA',
  isAdmin: false,
  geolocationUrl: env['GEOLOCATION_URL'] || 'https://geolocation.thkee.com',
  supportedLanguages: [
    { code: 'ar-SA', name: 'Arabic' },
    { code: 'en-US', name: 'English' },
  ],
  tapPublicKey: env['QA_TAP_PUBLIC_KEY'] || 'pk_test_q6Odm4txscnSGBMje3hYoPC5',
  baseUrlWebsocket: env['QA_BASE_URL_WEBSOCKET'] || 'qa.check.thkee.dev',
  googleClientId:
    env['GOOGLE_CLIENT_ID'] || '1085924331203-k5rr1nanteeo77el8pf6ul0noue93o15.apps.googleusercontent.com',

  firebaseConfig: {
    apiKey: env['FIREBASE_API_KEY'] || 'AIzaSyCDGeitXmkuTwGKggtLrg1O9NHXZEaH4aQ',
    authDomain: env['FIREBASE_AUTH_DOMAIN'] || 'thkee-qa.firebaseapp.com',
    projectId: env['FIREBASE_PROJECT_ID'] || 'thkee-qa',
    storageBucket: env['FIREBASE_STORAGE_BUCKET'] || 'thkee-qa.firebasestorage.app',
    messagingSenderId: env['FIREBASE_MESSAGING_SENDER_ID'] || '628299107846',
    appId: env['FIREBASE_APP_ID'] || '1:628299107846:web:1a068e47156b0a52a93d87',
  },
  logRocketEnabled: env['LOG_ROCKET_ENABLED'] === 'true',
  siteKey: env['SITE_KEY'] || '0x4AAAAAAABUtlO8-1LJhFyQ',
  videoJsLicense: env['VIDEO_JS_LICENSE'] || '100f5a560149555612',
  thkCookieDomain: env['THK_COOKIE_DOMAIN'] || '.thkee.dev',
  isLocalDev: false,
};
